export class AdeMesError extends Error {
    public data: {
        error: string
    };
    public status: number;
};

export class Operator {
    public userid: number;
    public username: string;
    public propertymap: { [key: string]: boolean };
};

export class LoginBean {
    public token: string;
    public messages: Array<string>;
    public warnings: Array<string>;
    public errors: Array<string>;
}

export class IJwtPayload {
    public userId: string;
    public username: string;
    public authorizations: Array<string>;
}

export class Customer {
    public id: string;
    public name: string;
    public logourl: string;
    public backgroundcolor: string;
    public projects: Array<Project>;
    public propertymap: { [key: string]: boolean };
}

export class Project {
    public id: string;
    public label: string;
    public projectlines: Array<ProjectLine>;
    public customer?: Customer;
    public propertymap: { [key: string]: boolean };
}

export class ProjectLine {
    public id: string;
    public label: string;
    public numphasegroups: number;
    public project?: Project;
    public propertymap: { [key: string]: boolean };
}

export class PhaseGroup {
    public id: string;
    public label: string;
    public phases: Array<PhaseDetails>;
    public propertymap: { [key: string]: boolean };
}

export class PhaseDetails {
    public id: string;
    public label: string;
    public state: string;
    public qtytotal: number;
    public qtyavailable: number;
    public datestart: string;
    public propertymap: { [key: string]: boolean };
    public isWorkFinished: boolean;
    public dateend: Date;
    public workedhours: number;
    public workedminutes: number;
    public setuphours: number;
    public setupminutes: number;
    public nchours: number;
    public ncminutes: number;
    public ncreason: string;
    public ncnotes: string;
    public isblocked: boolean;
    public isattrezzaggio: boolean;
    public notes: Array<any>;
    public idcustomer: string;
    public idproject: string;
    public idprojectline: string;
    public idreport: string;
    public idphasegroup: string;
    public fullphaselabel: string;
    public customization: Array<Customization>;

    //problema generico
    public ncgroup: string;
    public open: boolean=false;
}

export class Customization {
    public desktopSize: number;
    public mobileSize: number;
    public orderno: number;
    public phaseId: string;
    public phaseProp: string;
    public tabletSize: number;
}

export class Note {
    public id: string;
    public note: string;
    public author: string;
    public creationdate: Date;
    public propertymap: { [key: string]: boolean };
}

export class Attachment {
    public id: string;
    public type: string;
    public name: string;
    public url: string;
    public url2: string;
    public propertymap: { [key: string]: boolean };
    public idProjectNc: string;
    public idProjectUserTime: string;
}

export class TechnicalData {
    public id: string;
    public name: string;
    public value: string;
    public group: string;
    public propertymap: { [key: string]: boolean };
}

export class PhaseComponent {
    public id: string;
    public name: string;
    public qta: number;
    public unit: string;
    public components?: Array<PhaseComponent>;
    public pos: number;
    public checklot: number;
    public lot: string;
}

export class Report {
    public id: string;
    public date: Date;
    public customer: string;
    public numstart: number;
    public totalhours: number;
    public setuphours: number;
    public nchours: number;
    public notes: string;
    public ncnotes: string;
    public state: string;
    public progress: number;
    public progresscolor: string;
    public isblocked: boolean;
    public commessa_completa: string;
    public attributes: Array<ReportAttrib>;
    public propertymap: { [key: string]: boolean };
}

export class ReportGroup {
    public customer: string;
    public totalhours: number;
    public setuphours: number;
    public nchours: number;
    public progress: number;
    public progresscolor: string;
}

export class ReportAttrib {
    public id: string;
    public label: string;
    public value: string;
}

export class Nonconformity {
    public id: string;
    public label: string;
};

export class GenericProblems {
    public id: string;
    public label: string;
    public value: string;
};

export class PhaseDescriptor {
    public customerId: string;
    public projectId: string;
    public projectLineId: string;
    public phaseId: string;
    public reportId: string;
    public state: string;
    public isWorkFinished: boolean;
    public fullphaselabel: string;

    public phaseDateStart: Date;
    public phaseHoursStart: number;
    public phaseMinutesStart: number;
    public phaseDateEnd: Date;
    public phaseHoursEnd: number;
    public phaseMinutesEnd: number;
    public phaseNote: string;

    public workedHours: number;
    public workedMinutes: number;

    public setupHours: number;
    public setupMinutes: number;

    public ncHours: number;
    public ncMinutes: number;

    public ncReason: string;
    public ncNotes: string;

    //problema generico
    public ncGroup: string;

    public propertymap: { [key: string]: boolean };

    public directStart: boolean;
    public directEnd: boolean;

    public ncPhotos: Array<any>;
    public type_nc: string;
};

export class Rfid {
    public name: string;
    public uuid: string;
};

export class RfidPhase {
    public name: string;
    public id: string;
};

export class OrderCan {
    public description: string;
    public customerid: string;
    public projectid: string;
    public projectlineid: string;
};

export class PhaseRecap {
    public idcustomer: string;
    public idproject: string;
    public idprojectline: string;
    public idphasegroup: string;
    public idphase: string;
    public idpiano: string;
    public customer: string;
    public address: string;
    public project: string;
    public projectline: string;
    public phase: string;
    public expectedtime: string;
    public clock: boolean;
    public progress: number;
    public progresscolor: string;
    public idcalendarphasegroup: string;
    public productName: string;
    public plannedQty: string;
    public label: string;
    public datestart: string;
    public phasetitlehtml: string;
    isworkfinished: any;
    public open: boolean=false;
};

export class NCPhoto {
    public file: any;
    public src: any;
};

export class DatePhaseRecaps {
    public date: Date;
    public phaserecaps: Array<PhaseRecap>;
    dateNumber: any;
    dateDay: any;
    month: any;
    year: any;
    idDate: any;
};

export class RequestVacation {
    public userId: number;
    public type: string;
    public startDate: Date;
    public endDate: Date;
};

export class ReportRequest {
    public type: string;
    public startDate: Date;
    public endDate: Date;
    public note: string;
    public stato: string;
};

export class HourWork {
    public hourwork: string;
    public hourlastreport: string;
    public url: string;
};

export class SetEquipment {
    public idactivitydetails: number;
    public list: Array<EquipementList>;
};

export class EquipementList {
    public idtool: number;
    public idproblem: number;
};

export class SetDetailsHours {
    public idactivitydetails: number;
    public list: Array<ListHoursDetails>;
};

export class ListHoursDetails {
    public iddetails: number;
    public inithours: Date;
    public finalhours: Date;
    public tothours: number;
    public idactivitytype: number;
};

export class SetActivityDetails {
    public idactivitydetails: number;
    public idtype: number;
    public km: number;
    public workactivity: string;
    public type: string;
};

export class ListActivities {
    public idactivitydetails: number;
    public isworkfinished: boolean;
};

export class SetActivities {
    public idpiano: number;
    public activities: Array<ListActivities>;
    public lastupdate: Date;
};

export class SetReport {
    public idactivitydetails: number;
    public description: string;
    public products: Array<ProductsList>;
    public signature: string;
};

export class ProductsList {
    public idline: number;
    public idproducts: number;
    public qta: number;
};

export class SendEmailReport {
    public idactivitydetails: number;
    public email: Array<string>;
};

export class TzComunicationMessage {
    public id: number;
    public name: string;
    public description: string;
    public descExtract: string;
    public value: string;
    public startdate: Date;
    public enddate: Date;
    public createdBy: number;
    public creationdate: Date;
    public uptadedBy: number;
    public attachments: Array<TzComunicationMsgAttach>;
    public creator: string;
    public dateDay: Date;
    public dateNumber: Date;
    public count: boolean;
};

export class TzComunicationMsgAttach {
    public id: number;
    public messageId: number;
    public name: string;
    public description: string;
    public url: string;
};

export class SetMeansTransport {
    public idactivitydetails: number;
    public idplate: number;
    public kminit: number;
    public kmfinal: number;
    public control: Array<ControlMeansTransport>;
}

export class ControlMeansTransport {
    public idcontrol: number;
    public idvalue: number;
}

export class ncType {

    public mc_tipo_nc_id: string;
    public name_tipo_nc: string;
    public tipologies: Array<ncTipologyType>;
}

export class ncTipologyType {

    public mc_tipologia_tipo_nc_id: string;
    public name: string;
}

export class Nc {

    userId: string;
    projectLineId: string;
    phaseGroupId: string;
    phaseId: string;
    object: string;
    description: string;
    visibilita: string;
    analisiCausa: string;
    descrizioneTrattamento: string;
    confermaTrattamento: boolean;
    trattamentoConcluso: boolean;
    ncTypeId: string;
    ncTipologyId: string;
    operatoreId: string;
    addettoId: string;
    c_project_nc_id: string;
    num_nc: string;
    nome_cliente: string;
    nome_matricola: string;
    nome_commessa: string;
    nome_responsabile: string;
    list_usertime: Array<NcUserTime>;
    vendorId: string;
    vendorName: string;
    color: string;
    borderColor: string;

}

export class NcUserTime {
    public data: any;
    public nome_operatore: string;
    public id_operatore: string;
    public ore_consuntivate: number;
    public c_project_usertime_id: string;
    public hour: number;
    public minute: number;
    public projectLineId: string;
    public projectId: string;
    public projectNcId: string;
    public date_picker: Date;
    public descrizioneTrattamento: string;
    public confermaTrattamento: boolean;
    public trattamentoConcluso: boolean;
    public isDescription: boolean;
    public analisiCausa: string;
    public note: string;
}

export class Vendor {
    public value: string;
    public name: string;
}
export class ProductionPlan {
    public m_production_id: number;
    public m_productionplan_id: number;
    public m_productionplan_ref_id: number;
    public m_product_id: number;
    public productName: string;
    public m_attributesetinstance_id: number;
    public lotName: string;
    public expectedqty: number;
    public productionqty: number;
    public line: number;
    public palletCode: string;
    public processed: boolean;
    public productionPlanLines: Array<ProductionLineBean>;
    public description: string;
    public uomName: string;
    public weight: number;
    public showWeight: boolean;
    public isReverse: boolean;
}

export class ProductionLineBean {
    public m_productionline_id: number;
    public m_productionplan_id: number;
	public m_product_id: number;
	public m_production_id: number;
	public m_locator_id: number;
	public productName: string;
	public m_attributesetinstance_id: number;
	public lotName: string;
	public expectedqty: number;
	public productionqty: number;
	public line: number;
	public palletCode: string;
	public processed: boolean;
	public c_projectline_id: number;
    public movementdate: string;
    public movementqty: number;
    public discardqty: number;
    public discardType: string;
    public uomName: string;
    public lineWeight: number;
}

export class CheckListB1 {
    public id: number;
    public data: any;
    public ora: string;
    public n_bobina: number;
    public conf_tratt: boolean;
    public peso_inch: number;
    public peso_inch2: number;
    public peso_ades_sx: number;
    public peso_ades_dx: number;
    public centr_film: boolean;
    public corr_tensione: boolean;
    public ass_difetti: boolean;
}

export class CheckListB2 {
    public id: number;
    public data: any;
    public ora: string;
    public n_bobina: number;
    public conf_tratt: boolean;
    public peso_ades_sx: number;
    public peso_ades_dx: number;
    public centr_film: boolean;
    public corr_tensione: boolean;
    public ass_difetti: boolean;
    public ass_difetti_acc: boolean;
}

export class CheckListB3 {
    public id: number;
    public data: any;
    public ora: string;
    public n_bobina: number;
    public largh_bobina: number;
    public alt_fotog: number;
    public senso_svolg:boolean;
    public corr_tensione: boolean;
    public diam_bobina: number;
    public ass_difetti: boolean;
    public ass_difetti_acc: boolean;
    public check_specifiche: boolean;    
}

export class CheckListPref {
    public id: number;
    public data: any;
    public ora: string;
    public n_sacco: number;
    public mis_base: number;
    public soffietti_dx: number;
    public soffietti_sx: number;
    public altezza: number;
    public pinch_bottom_dx: number;
    public pinch_bottom_sx: number;
    public sald_fondo: number;
    public sald_k_dx: number;
    public sald_k_sx: number
    public sald_ant_dx: number;
    public sald_ant_sx: number;
    public sald_post_dx: number;
    public sald_post_sx: number;
    public conf_saldature: boolean;
    public conf_pinch_bottom: boolean;
    public check_riempimento: boolean;
    public check_centratura: boolean;
    public check_generali: boolean;
    public check_lotto: boolean;
    public check_printaglio: boolean;
    public check_centr_orriz: boolean;
    public dist_bocca: number;
}
